import React from 'react';
import Base from './Base';

export default class ClockInModal extends Base {
    state = { clocking: false };

    clockIn = () => {
        this.setState({ clocking: true });
        this.httpPost('api/v1/attendance/clockIn', {})
            .then(data => {
                if (data.status === 1) {
                    this.props.onClockedIn(data.clockInTime);
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ clocking: false });
                }
            });
    };

    render() {
        return (
            <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999 }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ borderRadius: '20px' }}>
                        <div className="modal-header" style={{ borderBottom: 'none', justifyContent: 'center' }}>
                            <h4 className="modal-title">شروع کار</h4>
                        </div>
                        <div className="modal-body text-center">
                            <p className="text-soft">برای آغاز فعالیت امروز، ورود خود را ثبت کنید.</p>
                            <button
                                className="btn btn-primary btn-lg"
                                onClick={this.clockIn}
                                disabled={this.state.clocking}
                            >
                                {this.state.clocking ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm mr-2"></span>
                                        در حال ثبت...
                                    </>
                                ) : 'ثبت ورود'}
                            </button>
                        </div>
                        {/* بدون footer و بدون دکمه بستن */}
                    </div>
                </div>
            </div>
        );
    }
}